<div class="pull-left text-muted" ng-show="(history || data.activity).data">
  <i class="fa fa-calendar" aria-hidden="true"></i>
  <strong ng-show="tipo != 'produtividade'">até </strong>{{(history || data.activity).data | date:'dd/MM/yyyy'}}
</div>
<button type="button" title="Imprimir" class="btn btn-sm pull-right btn-link" ng-click="print()">
  <i class="fa fa-print"></i>
</button>
<div class="clearfix"></div>
<div class="clearfix"></div>

<div class="title text-center">
  <h2>
    <strong>PRODUTIVIDADE</strong>
  </h2>
</div>

<div class="btn-group" uib-dropdown ng-show="tipo == 'produtividade'">
  <button type="button" class="btn btn-white btn-sm" uib-dropdown-toggle>
    <span ng-hide="isCulture">
      {{details.markers[0].objeto.cultivarForGroup.descricao | characters:35}} <span class="caret"></span>
    </span>
    <span ng-show="isCulture">
      {{details.markers[0].objeto.atividade | characters:35}} - Todas <span class="caret"></span>
    </span>
  </button>
  <ul class="dropdown-menu-right" uib-dropdown-menu role="menu">
    <li role="menuitem" ng-repeat="(key, value) in atividadesMarker">
      <a ng-click="setAtividadeMarkers(value, $event)" href="#">{{value[0].objeto.atividade | characters:35 | capitalize}} - Todas</a>
    </li>
    <li class="divider"></li>
    <li role="menuitem" ng-repeat="(key, value) in cultivaresMarker">
      <a ng-click="setCultivarMarkers(value, $event)" href="#">{{value[0].objeto.cultivarForGroup.descricao | characters:35}}</a>
    </li>
  </ul>
</div>

<div class="btn-group" uib-dropdown>
  <button type="button" class="btn btn-white btn-sm" uib-dropdown-toggle>
     {{estadioFilterLabel() | characters:35}} <span class="caret"></span>
  </button>
  <ul class="dropdown-menu-right" uib-dropdown-menu role="menu">
    <li role="menuitem">
      <a ng-click="setAllMarkers($event)" href="#">Todos</a>
    </li>
    <li role="menuitem" ng-repeat="estadioMarkers in estadiosMarkers">
      <a ng-click="setEstadioMarkers(estadioMarkers, $event)" href="#">
        {{(estadioMarkers.estadio.abreviatura + ' - ' + estadioMarkers.estadio.descricao) | characters:35}}
      </a>
    </li>
  </ul>
</div>

<div ng-hide="isCulture">
  <i class="icon-culture" aria-hidden="true"></i>
    <small class="text-italic">
      {{tipo !== 'produtividade' ? (details.markers[0].marker.cultivarForGroup.descricao) + ' -' : '' }}
      Plantio:
      <plantio safra="details.markers[0].objeto.params.safra_id" gleba="details.markers[0].objeto.params.gleba_id" insumo="details.markers[0].objeto.params.cd_insumo"/>
    </small>
</div>

<h3 ng-show="isCulture">
  <strong ng-if="!isAlgodao && !isCana">Estimativa: </strong> {{activityUnit}}
  <br>
</h3>

<h3 ng-hide="isCulture">
  <strong>Estimativa {{activityUnit}}</strong>
</h3>
<table class="table" ng-hide="isCulture">
  <tr>
    <td><strong>Meta</strong></td>
    <td class="text-right">
      {{(details.ideal || 0) | number:2}}
      <span class="pointer" ng-if="$root.permissions.contagem.canEditProductivity" ng-click="changeTargetProductivity()"><i class="fa fa-pencil-square" aria-hidden="true"></i></span>
    </td>
  </tr>
  <tr>
    <td><strong>Contada</strong></td>
    <td class="text-right">{{details.media | number:2}}</td>
  </tr>
  <tr>
    <td><strong>Variação (&Delta;%)</strong></td>
    <td class="text-right">{{details.variacao | number:2}}</td>
  </tr>
  <tr ng-if="!isCana">
    <td><strong>Fator de Correção </strong></td>
    <td class="text-right">{{details.correcao != null ? (details.correcao | number:2) + '%' : 'Valores diferentes' }}
        <span class="pointer" ng-if="$root.permissions.contagem.canEditProductivity" ng-click="changeCorrectionFactor()"><i class="fa fa-pencil-square" aria-hidden="true"></i></span>
    </td>
  </tr>
  <tr ng-if="!isCana">
    <td><strong>{{isAlgodao ? 'Peso do Capulho' : 'PMS'}}</strong></td>
    <td class="text-right" ng-if="!isAlgodao">{{details.pms ? (details.pms | number:0) : 'Valores diferentes' }}
      <span class="pointer" ng-if="$root.permissions.contagem.canEditProductivity" ng-click="changePesos()"><i class="fa fa-pencil-square" aria-hidden="true"></i></span>
    </td>
    <td class="text-right" ng-if="isAlgodao">{{details.pesoCapulho ? (details.pesoCapulho | number:0) + ' g' : 'Valores diferentes' }}
      <span class="pointer" ng-if="$root.permissions.contagem.canEditProductivity" ng-click="changePesos()"><i class="fa fa-pencil-square" aria-hidden="true"></i></span>
    </td>
  </tr>
  <tr ng-if="isCana">
    <td><strong>Peso Bruto</strong></td>
    <td class="text-right">{{(details.rawWeight | number:0) + ' ton/ha'}}</td>
  </tr>
  <tr ng-if="isCana">
    <td><strong>Peso Estimado Final</strong></td>
    <td class="text-right">{{(details.estimatedFinalWeight | number:0) + ' ton/ha'}}</td>
  </tr>
</table>

<colheita safra="details.markers[0].objeto.params.safra_id"
          gleba="details.markers[0].objeto.params.gleba_id"
          atividade="details.markers[0].objeto.params.atividade_id">
</colheita>

<span ng-if="details.classificacao_milho">
  <h3>
    <strong>Classificação milho</strong>
  </h3>
  <table class="table">
    <tr>
      <td><strong>Espigas/ha</strong></td>
      <td class="text-right">{{details.classificacao_milho.espigas | number:2}}</td>
    </tr>
    <tr>
      <td><strong>Peso médio por espiga</strong></td>
      <td class="text-right">{{details.classificacao_milho.peso | number:2}}g</td>
    </tr>
  </table>
</span>

<h3 ng-show="details.markers.length > 1">
  <strong>Detalhamento</strong>
</h3>
<table ng-show="details.markers.length > 1" class="table">
  <tr>
    <td><strong>Nº de Amostras</strong></td>
    <td class="text-right">{{details.quantidade}}</td>
  </tr>
  <tr>
    <td><strong>Maior</strong></td>
    <td class="text-right">{{details.maxima | number:2}}</td>
  </tr>
  <tr>
    <td><strong>Menor</strong></td>
    <td class="text-right">{{details.minima | number:2}}</td>
  </tr>
</table>

<div ng-hide="isCulture" id="chartProductivity" class="chart-points">
  <div id="containerChartProductivity" class="height-100 width-100"></div>
</div>

<table ng-hide="isCulture" class="table">
  <thead>
    <tr>
      <th colspan="2">Faixas de Variação(&#916;%)</th>
    </tr>
  </thead>
  <tbody>
    <tr ng-repeat="(key, faixa) in details.faixas track by $index">
      <td>
        <span class="bg-{{ faixa.status }}">&nbsp;&nbsp;&nbsp;</span>
        <strong>{{key}}</strong>
      </td>
      <td>
        <ng-pluralize count="{{faixa.quantidade}}"
            when="{'0': 'sem registros',
                   'one': '{{faixa.quantidade}} ponto ({{faixa.percentual  | number:0 }}%)',
                   'other': '{{faixa.quantidade}} pontos ({{faixa.percentual  | number:0 }}%)'}">
        </ng-pluralize>
      </td>
    </tr>
  </tbody>
</table>

<table class="table">
  <thead>
    <tr>
      <th>Ponto</th>
      <th class="text-right">{{activityUnit}}
      <th ng-hide="isCulture" class="text-right">Variação</th>
    </tr>
  </thead>
  <tbody>
    <tr ng-repeat="point in details.markers | orderBy: 'created_at' track by $index"
        ng-mouseleave="resetAnimationMarker($index)"
        ng-mouseover="setAnimationMarker($index)"
        ng-class="{'info': $index == indexMarker, 'activate-line': point.marker.isOpen || point.leafletMarker.isPopupOpen(), 'inactive-row' : !point.objeto.registroAtivo}"
        ng-click="openMarkerInfoWindow($index)" class="pointer">
      <td>Ponto {{$index + 1}}</td>
      <td class="text-right">{{point.objeto.realized | number:2}}</td>
      <td ng-hide="isCulture" class="text-right">{{point.objeto.variation | number:2}}%</td>
    </tr>
  </tbody>
</table>


<!-- Botão para ser chamar impressão, só pode ser chamado depois de carregar os dados da função print() -->
<!-- TODO: Mover para componente (diretiva) -->
<button id="hidden-print-produtividade" ng-print print-element-id="print-produtividade" class="hidden"></button>
<div id="print-produtividade" class="only-print" ng-if="report.ready">
  <h2>{{details.gleba.descricao}}</h2>
  <h3>Estimativa de produtividade de {{details.atividade.descricao}} <small>{{report.pontos[0].objeto.cultivarForGroup.descricao}} ({{report.plantio.area | number:1}}ha)</small></h3>

  <p>Data da estimativa: {{report.periodo.fim | date: 'dd/MM'}}</p>
  <p>Responsável pela estimativa: {{report.responsaveis}}</p>
  <br />

  <p>Data de semeadura: {{report.plantio.inicio | date:'dd/MM/yy'}} <span ng-if="report.plantio.inicio != report.plantio.fim">{{report.plantio.fim | date:'dd/MM/yy'}}</span></p>
  <p>Data de emergência: {{report.informacaoCultivar.data_emergencia | date:'dd/MM'}}</p>
  <p>Data estimada para colheita: {{report.informacaoCultivar.data_estimada_colheita | date:'dd/MM'}}</p>
  <br />

  <p>Produtividade Estimada: {{details.media | number:0}} {{activityUnit}}</p>
  <p>Produtividade Meta: {{(details.ideal || 0) | number:0}} - Variação: {{details.variacao | number:2}}%</p>
  <p ng-if="report.areaPorAmostragem">Área por ponto de amostragem: {{report.areaPorAmostragem | number:2}}m²</p>
  <br />

  <p ng-if="details.correcao">Fator de Correção: {{details.correcao | number:2}}%</p>
  <p ng-if="details.pms">PMS: {{details.pms | number:0}}g</p>
  <br />

  <h4>Pontos</h4>
  <table class="table table-bordered table-produtividade">
    <thead>
      <tr>
        <th class="col-md-1 text-center">Ponto</th>
        <th class="text-right col-md-2">Média {{activityUnit}}</th>
        <th class="text-right col-md-2">Variação</th>
        <th class="first-line" colspan="{{report.maxSamples}}">Amostras</th>
        <th>Médias</th>
      </tr>
      <td>
        <td colspan="2"></td>
        <td ng-class="{'first-line': $first}" class="col-md-1 text-left line-value" ng-repeat="index in [].constructor(report.maxSamples) track by $index"><b>{{$index+1}}</b></td>
        <td>&nbsp;</td>
      </td>
    </thead>
    <tbody>
      <tr ng-repeat="point in report.pontos | orderBy: 'created_at' track by $index">
        <td class="col-md-1 text-center">{{$index + 1}}</td>
        <td class="col-md-2 text-right">{{point.objeto.realized | number:0}}</td>
        <td class="col-md-2 text-right">{{point.objeto.variation | number:2}}%</td>
        <td class="col-md-1 text-left line-value" ng-class="{'first-line': $first}" ng-repeat="sample in point.objeto.samples">
          <ng-include src="'sample-produtividade-trigo.html'" ng-if="sample.spike"></ng-include>
          <ng-include src="'sample-produtividade-milho.html'" ng-if="point.objeto.classifications"></ng-include>
          <ng-include src="'sample-produtividade-soja.html'" ng-if="sample.nodes != null"></ng-include>
          <ng-include src="'sample-produtividade-algodao.html'" ng-if="sample.capulhos !== null"></ng-include>
        </td>
        <td ng-repeat="index in [].constructor(report.maxSamples - point.objeto.samples.length) track by $index">&nbsp;</td>
        <td>
          <ng-include src="'sample-produtividade-trigo-media.html'" ng-if="point.objeto.samples[0].spike"></ng-include>
          <ng-include src="'sample-produtividade-milho-media.html'" ng-if="point.objeto.classifications"></ng-include>
          <ng-include src="'sample-produtividade-soja-media.html'" ng-if="point.objeto.samples[0].nodes != null"></ng-include>
          <ng-include src="'sample-produtividade-algodao-media.html'" ng-if="point.objeto.samples[0].capulhos > 0"></ng-include>
        </td>
      </tr>
    </tbody>
  </table>
  <small class="text-right">Gerado na plataforma Aqila em {{report.date | date:'dd/MM/yy HH:mm'}}</small>
</div>

<script type="text/ng-template" id="sample-produtividade-trigo.html">
  Espigas: <strong>{{sample.spike | number}}</strong><br />
  Espiguetas por Espiga: <strong>{{sample.spikelet | number}}</strong><br />
  Grãos por Espiguetas: <strong>{{sample.grains | number}}</strong>
</script>

<script type="text/ng-template" id="sample-produtividade-milho.html">
  <p ng-repeat="(key, espiga) in sample">
    {{espiga.corns}} espigas de {{espiga.classification.weight}}g
  </p>
</script>

<script type="text/ng-template" id="sample-produtividade-soja.html">
  <p ng-if="sample.unproductive_nodes">Nós improdutivos: <strong>{{sample.unproductive_nodes | number}}</strong></p>
  <p ng-if="sample.nodes">Nós: <strong>{{sample.nodes | number}}</strong></p>
  <p ng-if="sample.pods">Vagens: <strong>{{sample.pods | number}}</strong></p>
  <p ng-if="sample.grains">Grãos: <strong>{{sample.grains | number}}</strong></p>
</script>

<script type="text/ng-template" id="sample-produtividade-algodao.html">
  {{sample.capulhos}} capulhos totalizando {{sample.peso}}g
</script>

<script type="text/ng-template" id="sample-produtividade-trigo-media.html">
  <p ng-if="(point.objeto.samples | average:'spike')">Espigas: <strong>{{point.objeto.samples | average:'spike' | number}}</strong></p>
  <p ng-if="(point.objeto.samples | average:'spikelet')">Espiguetas por Espiga: <strong>{{point.objeto.samples | average:'spikelet' | number}}</strong></p>
  <p ng-if="(point.objeto.samples | average:'grains')">Grãos por Espiguetas: <strong>{{point.objeto.samples | average:'grains' | number}}</strong></p>
</script>


<script type="text/ng-template" id="sample-produtividade-soja-media.html">
  <p ng-if="(point.objeto.samples | average:'unproductive_nodes')">Nós improdutivos: <strong>{{point.objeto.samples | average:'unproductive_nodes' | number}}</strong></p>
  <p ng-if="(point.objeto.samples | average:'nodes')">Nós: <strong>{{point.objeto.samples | average:'nodes' | number}}</strong></p>
  <p ng-if="(point.objeto.samples | average:'pods')">Vagens: <strong>{{point.objeto.samples | average:'pods' | number}}</strong></p>
  <p ng-if="(point.objeto.samples | average:'grains')">Grãos: <strong>{{point.objeto.samples | average:'grains' | number}}</strong></p>
</script>

<script type="text/ng-template" id="sample-produtividade-milho-media.html">
  <p ng-repeat="(key, espiga) in point.objeto.samples[0]">
    {{point.objeto.samples | average: (espiga.classification.description + '.corns') | number:1}} espigas de {{espiga.classification.weight}}g
  </p>
</script>

<script type="text/ng-template" id="sample-produtividade-algodao-media.html">
  {{point.objeto.samples | average: 'capulhos' | number:1}} capulhos totalizando {{point.objeto.samples | average: 'peso' | number:1}}g
</script>
